import React from 'react'
import PropTypes from 'prop-types'
import { Row, Col } from 'react-flexbox-grid'
import { emptyState } from '../../assets/images'

const NoResultsMsg = (props) => {
  const isGraphic = props.image
  return (
    <div>
      {isGraphic ? (
        <Row center='xs' className='emptyGraphic'>
          <Col>
            <img src={emptyState} alt='Empty State' />
            <p>{props.message}</p>
          </Col>
        </Row>
      )
        : (
          <Row>
            <Col>
              <p>{props.message}</p>
            </Col>
          </Row>
        )
      }
    </div>
  )
}

NoResultsMsg.propTypes = {
  message: PropTypes.string.isRequired,
  image: PropTypes.bool
}

export default NoResultsMsg



// WEBPACK FOOTER //
// ./src/widgets/common/NoResultsMsg.js